import { getDataMapper, mapField } from "@/shared";

export const mapTranslationToServer = getDataMapper({
    namespace: mapField("namespace"),
    key: mapField("key"),
    translations: mapField(
        "translations",
        getDataMapper({
            lang: mapField("lang"),
            translation: mapField("translation"),
        }),
    ),
});
